import React, { useState, useEffect, useMemo } from "react";
import { Col, Form, InputGroup, Nav, Row, Tab } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Help.css";
import Search from "../../../assets/images/search-line.svg";
import DeclarationsTable from "../modals/table/DeclarationsTable";
import PendingApprovals from "../modals/table/PendingApprovals";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  GetDeclarationTypeListAsync,
  selectDeclarationTypeList,
  GetMyDeclarationAsync,
  selectGetMyDeclaration,
  selectAddMyDeclaration,
  selectEditMyDeclaration,
  GetApprovalDeclarationListAsync,
  selectPendingDeclaration,
  selectUpdateDeclarationStatus,
  GetYearListAsync,
  selectYearList,
  selectCOIChatList,
  selectUserDetails,
} from "../../../features/helpandassistance/DeclarationSlice";
import { isPermited } from "../../../features/localStorage";
import DeclarationFormNew from '../modals/DeclarationFormNew';
import { useHistory } from 'react-router-dom';
import { GetCoiSectorList } from '../../../features/helpandassistance/SectorListSLice';
import PaginationComponent from '../../../components/Pagination/PaginationComponent';
import DropdownNew from '../../../components/dropdown/DropdownNew';

const Declarations = () => {
  const history = useHistory();

  const declarationType = useAppSelector(selectDeclarationTypeList);
  const myDeclaration = useAppSelector(selectGetMyDeclaration);
  const addDeclaration = useAppSelector(selectAddMyDeclaration);
  const editDeclaration = useAppSelector(selectEditMyDeclaration);
  const YearList = useAppSelector(selectYearList);
  const pendingList = useAppSelector(selectPendingDeclaration);
  const changeStatus = useAppSelector(selectUpdateDeclarationStatus);
  const chatList = useAppSelector(selectCOIChatList);
  const userDetails = useAppSelector(selectUserDetails);

  const dispatch = useAppDispatch();

  const [selectedOption, setSelectedOption] = useState<string>("");
  const [year, setYear] = useState("");
  const [searchData, setsearchData] = useState("");
  const [selectedNav, setSelectedNav] = useState<string>("");
  const [pageNo, setPageNo] = useState(1);

  var query = {
    conflictCategoryMasterId: selectedOption ? selectedOption : '',
    year: year ? year : '',
    q: searchData
  };

  useEffect(() => {
    if(!!userDetails && !userDetails?.mandmEmployee) {
      history.push('/home');
    }
  }, [userDetails]);

  useEffect(() => {
    setSelectedOption("");
    setYear("");
    setsearchData("");
  }, [selectedNav]);

  useEffect(() => {
    dispatch(GetDeclarationTypeListAsync());
    dispatch(GetYearListAsync());
    dispatch(GetCoiSectorList());
  }, []);

  useEffect(() => {
    dispatch(GetMyDeclarationAsync(query));
  }, [
    addDeclaration,
    editDeclaration,
    selectedOption,
    year,
    searchData,
    changeStatus,
    chatList,
  ]);

  useEffect(() => {
    const queryNew = { ...query, status: "0" };
    dispatch(GetApprovalDeclarationListAsync(queryNew));
  }, [
    addDeclaration,
    editDeclaration,
    changeStatus,
    selectedOption,
    year,
    searchData,
    chatList,
  ]);

  const yearList = useMemo(()=> {
    return YearList?.length>0 ? YearList.reduce(
      (prev: any, val: any) => [...prev, { label: val, val: val }],
      []
    ) : [];
  }, [YearList]);

  // useEffect(() => {
  //   async function fetchGiftDeclarationData() {
  //     let sample = await dispatch(GetgiftDeclarations(data));
  //   }
  //   fetchGiftDeclarationData();
  //   async function fetchLectureDeclarationData() {
  //     let sample = await dispatch(GetLectureDeclarations(data));
  //   }
  //   fetchLectureDeclarationData();
  //   async function fetchYearData() {
  //     let sample = await dispatch(GetYearList());
  //   }
  //   fetchYearData();
  // }, []);
  //console.log(selectedOption,"selectedOption")
  const searchItems = (searchValue: any) => {
    setsearchData(searchValue);

    // await dispatch(GetgiftDeclarations(data));

    // await dispatch(GetLectureDeclarations(data));
  };

  const GetDeclarationType = (id: any) => {
    let result = declarationType?.find((x) => x.id === id);
    return result?.declarationName;
  };

  return (
    <div style={styles.mainDiv}>
      <Tab.Container defaultActiveKey='first'>
        <Row>
          <Col sm={10} style={{ paddingTop: 15 }}>
            <h4 style={styles.heading}>Conflict Of Interest</h4>
          </Col>
          <Col sm={2} className='desk mb-3'>
            {/* <DeclarationForm isEdit={false} /> */}
            <DeclarationFormNew isEdit={false} />
          </Col>
        </Row>

        <Form>
          <Row>
            <Col sm={4} className='mt-0 mb-3'>
              <DropdownNew
                // label='Category'
                dataSet={declarationType}
                placeholder='Select Category'
                getOptionLabel='title'
                getOptionValue='id'
                selectedValue={selectedOption}
                onSelectedValueChange={setSelectedOption}
              />
            </Col>
            <Col sm={4} className=''>
              <DropdownNew
                // label='Year'
                dataSet={yearList}
                placeholder='Select Year'
                getOptionLabel='label'
                getOptionValue='val'
                selectedValue={year}
                onSelectedValueChange={setYear}
              />
            </Col>
            <Col sm={4} className=''>
              <InputGroup
                id='searchbar'
                style={{ border: 'solid 1px #e4e4e4' }}
              >
                <Image
                  style={styles.image1}
                  className='d-inline border-0 my-auto mx-2'
                  src={Search}
                  fluid
                />
                <Form.Control
                  onChange={(e) => searchItems(e.target.value)}
                  value={searchData}
                  name={searchData}
                  className='border-0 shadow-none ps-0'
                  style={styles.text1}
                  type='text'
                  placeholder='Search'
                />
              </InputGroup>
            </Col>
          </Row>
        </Form>
        <Row className='mx-auto pb-0'>
          <Col sm={12} className='px-0'>
            <Nav onSelect={(selectedKey: any) => setSelectedNav(selectedKey)}>
              <Nav.Item style={styles.tabHeading}>
                <Nav.Link className='tabs1' eventKey='first'>
                  My Declarations
                </Nav.Link>
              </Nav.Item>
              {userDetails?.coiAdmin && (
                <Nav.Item style={styles.tabHeading}>
                  <Nav.Link eventKey='second' className='tabs1'>
                    Pending Approvals
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
          </Col>
        </Row>
        <div style={styles.line}></div>
        <Row className='mx-auto mt-0'>
          <Col sm={12} className='px-0'>
            <Tab.Content>
              <Tab.Pane eventKey='first'>
                <DeclarationsTable
                  tData={myDeclaration}
                  GetDeclarationType={GetDeclarationType}
                />
              </Tab.Pane>
              <Tab.Pane eventKey='second'>
                <PendingApprovals
                  tData={pendingList}
                  GetDeclarationType={GetDeclarationType}
                />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
        {/* <Row>
          <Col xs={12} className=''>
            <PaginationComponent
              recordsPerPage={20}
              totalRecords={104}
              pageNo={pageNo}
              setPageNo={setPageNo}
            />
          </Col>
        </Row> */}
      </Tab.Container>
    </div>
  );
};

const styles: any = {
  mainDiv: {
    backgroundColor: '#fff',
    padding: '20px',
  },
  heading: {
    fontFamily: "Georama-Regular",
    fontSize: "14px",
    fontWeight: "bold",
    fontStrech: "normal",
  },
  subHeading: {
    // fontFamily: "Saira",
    fontSize: "14px",
    fontWeight: "medium",
    marginTop: "10px",
    marginBottom: "15px",
  },
  details: {
    // fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.5,
  },
  helpline: {
    // fontFamily: "Saira",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "normal",
    fontStretch: "normal",
    paddingLeft: "15px",
    paddingRight: "15px",
    textAlign: "left",
  },
  button: {
    padding: "14px 14px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: 500,
    fontStretch: "normal",
  },
  bottomLine: {
    border: "1px solid #eeeeee",
    margin: "10px 0px",
  },
  tabHeading: {
    fontFamily: "Saira",
    fontSize: "14px",
    fontWeight: "500",
    color: "#6d6e71",
  },
  line: {
    height: "1px",
    margin: "0px",
    backgroundColor: "#e4e4e4",
  },
  image1: {
    width: "24px",
    height: "24px",
  },
  text1: {
    fontFamily: "Saira",
    fontSize: "16px",
    color: "#6d6e71",
  },
  anchor: {
    backgroundColor: "#fff",
    color: "#e31837",
    fontFamily: "Saira",
    fontWeight: 600,
    fontSize: "12px",
    textTransform: "uppercase",
  },
};

export default Declarations;
